// src/components/zones/ThalwegTrench/PiraibaCatfish.jsx
import React, { useRef, useEffect } from 'react';
import '../../../css/swim.css';

export default function SwimmingPiraibaCatfish({
  width = 80,
  swimDuration = '30s',
  tailDuration = '0.8s',
  minTop = 80,
  maxTop = 100,
  onClick,
  highlight = false,
}) {
  const wrapperRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const wrapperEl = wrapperRef.current;
    const imgEl = imgRef.current;
    if (!wrapperEl || !imgEl) return;

    const randomStartTop = minTop + Math.random() * (maxTop - minTop);
    wrapperEl.style.top = `${randomStartTop}%`;

    wrapperEl.style.animationDuration = swimDuration;
    imgEl.style.animationDuration = tailDuration;
  }, [swimDuration, tailDuration, minTop, maxTop]);

  const wrapperClass = [
    'swim-boto-wrapper',
    highlight ? 'inline-block ring-4 ring-yellow-300 rounded-full scale-110' : '',
  ].filter(Boolean).join(' ');

  const piraibaCatfishUrl = '/images/animals/80_100m/predator/piraiba_catfish_head.png';

  const handleKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      ref={wrapperRef}
      className={wrapperClass}
      style={{ left: 0, position: 'absolute', pointerEvents: 'none' }} // let clicks pass through wrapper
    >
      <img
        ref={imgRef}
        src={piraibaCatfishUrl}
        alt="Piraíba Catfish"
        className="swim-boto-img"
        onClick={onClick}                // click only on the visible fish
        onKeyDown={handleKeyDown}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        draggable={false}
        style={{
          width: `${width}px`,
          pointerEvents: 'auto',         // re-enable on the image
          display: 'block',
          cursor: onClick ? 'pointer' : 'default',
        }}
      />
    </div>
  );
}
